<template>
  <div class="page-header-index-wide">
    <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
      <div class="account-settings-info-main" :class="device">
        <div class="account-settings-info-left">
          <a-menu
            :mode="device == 'mobile' ? 'horizontal' : 'inline'"
            :style="{ border: '0', width: device == 'mobile' ? '560px' : 'auto'}"
            :defaultSelectedKeys="defaultSelectedKeys"
            type="inner"
            @openChange="onOpenChange"
          >
            <!-- <a-menu-item v-if="showList.wxappShow" key="/system/pay/wxapp-pay">
              <router-link :to="{ name: 'WxappPay' }">
                微信小程序支付
              </router-link>
            </a-menu-item> -->
            <a-menu-item key="/system/pay/wxpay">
              <router-link :to="{ name: 'WxAppPay' }">
                微信支付
              </router-link>
            </a-menu-item>
            <a-menu-item key="/system/pay/alipay">
              <router-link :to="{ name: 'Alipay' }">
                支付宝支付
              </router-link>
            </a-menu-item>
          </a-menu>
        </div>
        <div class="account-settings-info-right">
          <!-- <div class="account-settings-info-title">
            <span>{{ $route.meta.title }}</span>
          </div> -->
          <route-view></route-view>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
// import _ from 'lodash'
// import { getSetting } from '@/api/system'
import { PageView, RouteView } from '@/layouts'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  components: {
    RouteView,
    PageView
  },
  mixins: [mixinDevice],
  data () {
    return {
      // horizontal  inline
      mode: 'inline',
      openKeys: [],
      defaultSelectedKeys: [],
      pageTitle: '',
      showList: {
        wxappShow: true,
        wechatShow: false,
        alipayShow: false
      }
    }
  },
  created () {
    this.updateMenu()
    // this.getSetting()
  },
  methods: {
    // getSetting () {
    //   getSetting().then(res => {
    //     if (_.get(res, 'code') === 200) {
    //       const data = _.get(res, 'data', {})
    //       for (const i in data) {
    //         if (data[i] === 'pay_wxapp') {
    //           this.showList.wxappShow = true
    //         }
    //         if (data[i] === 'pay_wechat') {
    //           this.showList.wechatShow = true
    //         }
    //         if (data[i] === 'alipay') {
    //           this.showList.alipayShow = true
    //         }
    //       }
    //     }
    //   })
    // },
    onOpenChange (openKeys) {
      this.openKeys = openKeys
    },
    updateMenu () {
      const routes = this.$route.matched.concat()
      this.defaultSelectedKeys = [ routes.pop().path ]
    }
  }
}
</script>

<style lang="less" scoped>
  .account-settings-info-main {
    width: 100%;
    display: flex;
    height: 100%;
    overflow: auto;

    &.mobile {
      display: block;

      .account-settings-info-left {
        border-right: unset;
        border-bottom: 1px solid #e8e8e8;
        width: 100%;
        height: 50px;
        overflow-x: auto;
        overflow-y: scroll;
      }
      .account-settings-info-right {
        padding: 20px 40px;
      }
    }

    .account-settings-info-left {
      border-right: 1px solid #e8e8e8;
      width: 224px;
    }

    .account-settings-info-right {
      flex: 1 1;
      padding: 8px 40px;

      .account-settings-info-title {
        color: rgba(0,0,0,.85);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 12px;
      }
      .account-settings-info-view {
        padding-top: 12px;
      }
    }
  }
</style>
